module.exports = __webpack_public_path__ + "static/media/monet-13.b33daea5.jpeg";